import React from "react";
import "./FormInput.css";

const FormInput = ({
  label,
  type = "text",
  name,
  value,
  onChange,
  error,
  required = false,
  placeholder = "",
  rows,
}) => {
  const inputElement =
    type === "textarea" ? (
      <textarea
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows || 5}
        className={error ? "error" : ""}
      />
    ) : (
      <input
        type={type}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={error ? "error" : ""}
      />
    );

  return (
    <div className="form-input">
      <label htmlFor={name}>
        {label}
        {required && <span className="required">*</span>}
      </label>
      {inputElement}
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default FormInput;
